import React from 'react';

const LogsPageContext = React.createContext({});
export default LogsPageContext;
